import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  label: {
    fontSize: '1rem',
    color: theme.evPalette.charcoal[800],
    marginBottom: theme.spacing(1),
    '&.Mui-error': {
      color: `${theme.evPalette.rose[900]} !important`,
    },
    width: 'fit-content',
  },

  asterisk: {
    color: `${theme.evPalette.rose[900]} !important`,
  },

  fieldContainer: {
    marginBottom: theme.spacing(3),
    '& .myev-MuiFormHelperText-contained': {
      marginLeft: 0,
    },
    '& .myev-MuiCheckbox-root': {
      marginLeft: '-9px',
    },
    '@media (max-width: 340px)': {
      flex: 1,
    },
  },

  countryOptions: {
    borderRadius: 4,
    fontSize: 16,
    '& .myev-MuiOutlinedInput-input': {
      padding: '10.5px 14px',
    },
  },

  addressInputText:
  {
    '& > .Mui-error > fieldset': {
      borderColor: `${theme.evPalette.rose[900]} !important`,
    },
  },

  phoneContainer: {
    gap: '16px',
  },

  secondaryPhoneContainer: {
    gap: '16px',
  },

  phoneInputText:
  {
    maxWidth: '179px',
    '& > .Mui-error > fieldset': {
      borderColor: `${theme.evPalette.rose[900]} !important`,
    },
  },

  phoneExtInputText: {
    maxWidth: '67px',
    textWrap: 'nowrap',
    '@media (max-width: 640px)': {
      textWrap: 'wrap',
    },
  },

  secondaryPhoneInputText:
  {
    maxWidth: '179px',
    '& > .Mui-error > fieldset': {
      borderColor: `${theme.evPalette.rose[900]} !important`,
    },
  },

  addressInputHelperText: {
    color: `${theme.evPalette.rose[900]} !important`,
  },

  cityStateContainer: {
    marginBottom: theme.spacing(3),
    '& .myev-MuiFormHelperText-contained': {
      marginLeft: 0,
    },
    '& .myev-MuiCheckbox-root': {
      marginLeft: '-9px',
    },
    gap: '16px',
  },

  cityContainer: {
    flex: '3 1 0',
    '@media (max-width: 640px)': {
      flex: '18 1 0',
    },
    '@media (max-width: 400px)': {
      flex: '15 1 0',
    },
  },

  stateContainer: {
    flex: '1 1 0',
    '@media (max-width: 640px)': {
      flex: '7 1 0',
    },
    '@media (max-width: 400px)': {
      flex: '7 1 0',
    },
  },

  zipContainer: {
    flex: '1 1 0',
    '@media (max-width: 640px)': {
      flex: '9 1 0',
    },
    '@media (max-width: 400px)': {
      flex: '9 1 0',
    },
  },

  stateOptions: {
    borderRadius: 4,
    fontSize: 16,
    '& .myev-MuiOutlinedInput-input': {
      padding: '10.5px 14px',
    },
  },
  optionalLabel: {
    fontWeight: '400',
  },
  buttonContainer: {
    gap: '15px',
    flexDirection: 'row',
    '@media (max-width: 640px)': {
      flexDirection: 'column',
    },
  },

  button: {
    '@media (max-width: 640px)': {
      width: '100%',
      height: '44px',
    },
  },
  checkboxLabel: {
    fontSize: '14px',
    color: theme.evPalette.charcoal[900],
    fontWeight: '400',
  },
}));
